import React from "react";
import styles from "../styles.module.scss";

// Table body props
interface TableBodyProps {
  customClassName?: string;
  children: any;
  style?: React.CSSProperties;
  onClick?: () => void;
}

/**
 * This is a representation of HTML's tbody component
 * ---------------------------------------------------
 * @param customClassName - @interface TableBodyProps
 *
 */

const TableBody: React.FC<TableBodyProps> = ({
  children,
  customClassName = "",
}) => {
  return (
    <section className={`${styles.tableBody} ${customClassName}`}>
      {children}
    </section>
  );
};

const TableBodyRow: React.FC<TableBodyProps> = ({
  children,
  customClassName = "",
  style,
  onClick,
}) => {
  return (
    <div
      style={{ ...style, ...(onClick ? { cursor: "pointer" } : {}) }}
      className={`${styles.tableBodyRow} ${customClassName}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      {children}
    </div>
  );
};

export { TableBody, TableBodyRow };
